<template>
  <div class="mt-5 py-3">
    <v-layout row wrap v-if="list.length">
      <v-flex xs12 sm12>
        <v-container ma-0 grid-list-sm grid-list-md grid-list-lg>
          <v-layout row wrap>
            <v-flex
              v-for="(screener, index) in list"
              :key="screener.id"
              xs12
              sm12
              md3
            >
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  class="cursor-pointer"
                  :key="screener.title[currentLocale] + index"
                  style="height: 100%"
                  @click.stop="goToScreenerOverview(screener.id)"
                >
                  <!-- Show thumbnail of screener -->
                  <v-img
                    v-if="screener.thumbnail_url"
                    class="white--text"
                    :aspect-ratio="16/9"
                    :src="screener.thumbnail_url"
                  >
                    <!-- Reserved checkmark -->

                    <v-container
                      v-if="isConsumerEnrolled(screener.id)"
                      fill-height
                      fluid
                      pa-0
                      class="overlay"
                    >
                      <v-tooltip top color="white">
                        <template v-slot:activator="{ on }">
                          <v-layout
                            v-on="on"
                            column
                            wrap
                            fill-height
                            justify-center
                            align-center
                          >
                            <!-- <v-flex xs12> -->
                            <v-icon color="success" size="58"
                              >mdi-checkbox-marked-circle-outline</v-icon
                            >
                            <h2 class="success--text">
                              {{ $t(`${eventPrefix}.reserved.title`) }}
                            </h2>
                            <!-- </v-flex> -->
                          </v-layout>
                        </template>
                        <span class="secondary--text text--darken-3 body-1">
                          {{ $t(`${eventPrefix}.reserved.tooltip`) }}
                        </span>
                      </v-tooltip>
                    </v-container>
                  </v-img>
                  <!-- Show thumbnail of first film if thumbnail is not available on screener -->
                  <v-img
                    v-else-if="screener.films[0].thumburls"
                    class="white--text"
                    :aspect-ratio="16/9"
                    :src="screener.films[0].thumburls"
                  >
                    <!-- Reserved checkmark -->

                    <v-container
                      v-if="isConsumerEnrolled(screener.id)"
                      fill-height
                      fluid
                      pa-0
                      class="overlay"
                    >
                      <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                          <v-layout
                            v-on="on"
                            column
                            wrap
                            fill-height
                            justify-center
                            align-center
                          >
                            <!-- <v-flex xs12> -->
                            <v-icon color="success" size="58"
                              >mdi-checkbox-marked-circle-outline</v-icon
                            >
                            <h2 class="success--text">
                              {{ $t(`${eventPrefix}.reserved.title`) }}
                            </h2>
                            <!-- </v-flex> -->
                          </v-layout>
                        </template>
                        <span class="background--text body-1">
                          {{ $t(`${eventPrefix}.reserved.tooltip`) }}
                        </span>
                      </v-tooltip>
                    </v-container>
                  </v-img>
                  <v-card-title>
                    <div>
                      <div class="pb-2">
                        <span
                          v-if="screener.is_vod_event"
                          class="secondary--text text--lighten-2"
                        >
                          <span
                            v-if="
                              isConsumerEnrolled(screener.id) &&
                              vodEventStartTime(screener.id)
                            "
                          >
                            {{
                              moment
                                .utc(vodEventStartTime(screener.id))
                                .local()
                                .format("lll")
                            }} | &nbsp;
                          </span>

                          <span v-if="screener.venue" class="px-1"></span>
                          <span>{{ screener.venue[currentLocale] }}</span>
                        </span>
                        <span v-else class="secondary--text text--lighten-2">
                          <span
                            v-if="
                              isConsumerEnrolled(screener.id) &&
                              isConsumerEnrolled
                            "
                          ></span>
                          {{
                            moment
                              .utc(screener.screening_starts_at)
                              .local()
                              .format("lll")
                          }}
                          <span class="px-1" v-if="screener.venue">|&nbsp;</span>
                          <span>{{ screener.venue[currentLocale] }}</span>
                        </span>
                        <!-- Alert for geo-blocking -->
                        <v-tooltip
                          top
                          v-if="screener.is_geo_blocked"
                          color="primary"
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small color="error" class="px-1"
                              >mdi-alert</v-icon
                            >
                          </template>
                          <span class="background--text body-1">
                            {{ $t(`${eventPrefix}.geo_blocked`) }}
                          </span>
                        </v-tooltip>
                      </div>
                      <div v-if="screener.is_vod_event &&isConsumerEnrolled(screener.id)">
                        <v-chip v-if="isVodEventExpired(screener.id)" small color="error" text-color="white">{{ $t("vod_event.expired") }}</v-chip>
                        <v-chip v-if="isVodEventActive(screener.id)" small color="success" text-color="white">{{ $t("vod_event.active") }}</v-chip
                        >
                      </div>
                      <span
                        style="line-height:1.35 !important"
                        class='title mb-1 cursor-pointer underline-on-hover secondary--text'
                        @click.stop="goToScreenerOverview(screener.id)"
                        >{{ screener.title[currentLocale] }}
                      </span>
                      <!-- Show "Purchased" mark if purchased but not enrolled  -->
                      <PurchasedIndicator
                        v-if="
                          isConsumerPurchased(screener.id) &&
                          !isConsumerEnrolled(screener.id)
                        "
                        :eventPrefix="eventPrefix"
                      ></PurchasedIndicator>
                      <!-- Seats Status -->
                      <div v-if="!screener.is_vod_event &&!isArchiveMenu && !isConsumerEnrolled(screener.id)">
                        <span class="subheading secondary--text text--lighten-2"
                          >{{ $t(`${eventPrefix}.seats.title`) }}
                        </span>
                        <span
                          class="subheading"
                          v-html="getSeatsStatus(screener)"
                        ></span>
                      </div>
                      <!-- Event type -->
                      <div v-if="!screener.is_vod_event && screener.event_type > DEFINES.SCREENER_TYPE_VALUE.VIRTUAL">
                        <span class="subheading secondary--text"
                          >{{ $t(`screener.list.event.type`) }}
                        </span>
                        <v-chip small outline color="primary" class="ma-0">{{$t(DEFINES.SCREENER_TYPE_STR[screener.event_type])}}</v-chip>
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-actions class="px-3 pt-0">
                    <v-btn
                    color="primary background--text"
                    class="white--text mx-0"
                    @click.stop="goToScreenerOverview(screener.id)"
                    >{{ $t(`${eventPrefix}.view_detail.title`) }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout v-else row wrap justify-center align-center>
      <v-flex xs12>
        <div v-if="is_today" class="my-5 text-xs-center">
          <div class="display-1 primary--text">
            {{ $t("screening.no_found_msg_1") }}
          </div>
          <div class="subheading primary--text py-1">
            {{ $t("screening.no_found_msg_2") }}
          </div>
        </div>
        <div v-if="is_ongoing" class="my-5 text-xs-center">
          <div class="display-1 primary--text">
            {{ $t("screening.no_ongoing_msg") }}
          </div>
        </div>
         <div v-if="is_upcoming" class="my-5 text-xs-center">
          <div class="display-1 primary--text">
            {{ $t("screening.no_on_upcoming_msg") }}
          </div>
        </div>
         <div v-if="is_past" class="my-5 text-xs-center">
          <div class="display-1 primary--text">
            {{ $t("screening.no_past_event_msg") }}
          </div>
        </div>
        <div v-if="is_vod" class="my-5 text-xs-center">
          <div class="display-1 primary--text">
            {{ $t("screening.no_on_demand_msg") }}
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import PurchasedIndicator from "@/components/screener/PurchasedIndicator";
import { getSeatsStatus } from "@/mixins/screening";


export default {
  name: "List",
  data() {
    return {
      dialog: false,
      screener: null,
      pricingPlan: null,
    };
  },
  props: {
    list: {
      default: null,
    },
    is_today: {
      type: Boolean,
      default: false,
    },
    is_ongoing: {
      type: Boolean,
      default: false,
    },
    is_upcoming: {
      type: Boolean,
      default: false,
    },
    is_past: {
      type: Boolean,
      default: false,
    },
    is_vod: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PurchasedIndicator,
  },
  mixins: [getSeatsStatus],
  computed: {
    ...mapState({
      currentCompany: (state) => state.company.company,
    }),
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled",
      isConsumerPurchased: "isPurchased",
      vodEventStartTime: "getVodEventStartTime",
      vodEventEndTime: "getVodEventEndTime",
      isVodEventExpired: "isVodEventExpired",
      isVodEventActive: "isVodEventActive",
    }),
    isArchiveMenu: function () {
      return this.$route.name == "screeners.archive";
    },
    eventPrefix() {
      return this.$route.name == 'vod.movies' ?'vod' : 'screener'
    },
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    goToScreenerOverview(screener_id) {
      this.$router.push({
        name: "screeners.overview",
        params: {
          screener_id: screener_id,
        },
      });
    },
    goToWatchPage(screener) {
      this.$router.push({
        name: "screeners.watch",
        params: {
          screener_id: screener.id,
        },
      });
    },
  },
};
</script>

<style scoped>
.underline-on-hover:hover {
  border-bottom: 2px solid var(--v-secondary-base);
}
</style>
